import { render, staticRenderFns } from "./PaperImage.vue?vue&type=template&id=38abdb23&scoped=true&"
import script from "./PaperImage.vue?vue&type=script&lang=js&"
export * from "./PaperImage.vue?vue&type=script&lang=js&"
import style0 from "./PaperImage.vue?vue&type=style&index=0&id=38abdb23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abdb23",
  null
  
)

export default component.exports